import stl from "./BuyItWeDeliverIt.module.css";
import {useTranslation} from "@i18n";
import {CDN_LINK} from "@globalConfig";

const BuyItWeDeliverIt = () => {
    const {t} = useTranslation(["web_city"]);

    return (
        <>
            <div className={stl.CB_container}>
                <div className={stl.CB_textContainer}>
                    <h2>
                        {t("اشتريها و نوصلها لباب بيتك", {
                            ns: "web_city",
                        })}
                    </h2>
                    <p>
                        {t(
                            "من خلال شاحنات شركة سيارة الحديثة نوفر خدمات إيصال السيارة المراد شرائها لين باب بيتك لضمان الراحة الكاملة التي نسعى لتوفيرها في أي مكان داخل حدود المملكة العربية السعودية",
                            {
                                ns: "web_city",
                            }
                        )}
                    </p>
                </div>
                <img
                    src={CDN_LINK + "/assets/images/city/buy_it_we_deliver_it.webp"}
                    alt="buy it and we deliver it image"
                    loading="lazy"
                    width="450px"
                    height="200px"
                />
            </div>
        </>
    );
};

export default BuyItWeDeliverIt;
